/** Normalize the two input-description fields while reading legacy records safely. */
export function getDescriptions(record = {}) {
    const description1 = String(
        record.description1 ?? record['Description 1'] ?? record.description ?? record.Description ??
        record.itemDescription1 ?? record.itemDescription ?? ''
    ).trim();
    const description2 = String(
        record.description2 ?? record['Description 2'] ?? record.itemDescription2 ?? ''
    ).trim();
    return { description1, description2 };
}

/** Text consumed by search/AI services that still operate on one prompt string. */
export function combineDescriptions(record = {}, separator = '\n') {
    const { description1, description2 } = getDescriptions(record);
    return [description1, description2].filter(Boolean).join(separator);
}

export function withDescriptions(record = {}) {
    const { description1, description2 } = getDescriptions(record);
    return {
        ...record,
        description1,
        description2,
        // Transitional aliases for old IndexedDB records and service contracts.
        description: combineDescriptions({ description1, description2 }),
        itemDescription: description1,
        itemDescription1: description1,
        itemDescription2: description2,
    };
}
